import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class EntityCollection {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	subscribeAll(callback) {
		const args = {
			filterType: "all"
		};
		return this._rc.subscribe("ecosystem", "/entityCollections", args, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				if (callback) {
					callback(null, response);
				}
			}
		});
	}

	getCollectionsContainingEntity(entityId, callback) {
		const url = `/ecosystem/api/entityCollections/containingEntity?entity=${entityId}`;
		this._restClient.exec_get(url, callback);
	}

	getAll(callback) {
		const url = "/ecosystem/api/entityCollections";
		this._restClient.exec_get(url, callback);
	}

	// -- members - array of entityIds
	addMembers(collectionId, members, callback) {
		const url = `/ecosystem/api/entityCollections/${collectionId}/addMembers`;
		const body = JSON.stringify({ entityIds: members });
		this._restClient.exec_put(url, body, callback);
	}

	// -- members - array of entityIds
	removeMembers(collectionId, members, callback) {
		const url = `/ecosystem/api/entityCollections/${collectionId}/removeMembers`;
		const body = JSON.stringify({ entityIds: members });
		this._restClient.exec_put(url, body, callback);
	}

	addRemoveMemberToMulti(entityId, entityName, entityType, feedId, added, removed, callback) {
		const url = "/ecosystem/api/entityCollections/addRemoveMemberToMulti";
		const body = JSON.stringify({
			entityId,
			entityName,
			entityType,
			feedId,
			added,
			removed
		});
		this._restClient.exec_put(url, body, callback);
	}

	createCollection(name, entities, callback) {
		const url = "/ecosystem/api/entityCollections";
		const body = JSON.stringify({ name, entities });
		this._restClient.exec_post(url, body, callback);
	}

	deleteCollection(collectionId, callback) {
		const url = `/ecosystem/api/entityCollections/${collectionId}`;
		this._restClient.exec_delete(url, callback);
	}

	restoreCollection(collectionId, callback) {
		const url = `/ecosystem/api/entityCollections/${collectionId}/restore`;
		const body = JSON.stringify({ isDeleted: false });
		this._restClient.exec_put(url, body, callback);
	}

	// Update collection name
	updateCollection(collectionId, name, callback) {
		const url = `/ecosystem/api/entityCollections/${collectionId}`;
		const body = JSON.stringify({ name });
		this._restClient.exec_put(url, body, callback);
	}

	// shares argument - supports multiple org: level VIEW|EDIT
	// for both sharing and un-sharing
	//{
	//    "mariner_group":  "EDIT" ,
	//    "some_other_org":  "VIEW"
	//}
	shareCollection(collectionId, shares, callback) {
		const url = `/ecosystem/api/entityCollections/${collectionId}/share`;
		const body = JSON.stringify({ shares: shares });
		this._restClient.exec_put(url, body, callback);
	}

	unshareCollection(collectionId, shares, callback) {
		const url = `/ecosystem/api/entityCollections/${collectionId}/unshare`;
		const body = JSON.stringify({ shares: shares });
		this._restClient.exec_put(url, body, callback);
	}

	getCollectionsForPinningEntity(entityId, callback) {
		const url = `/ecosystem/api/entityCollections/forPinningEntity/${entityId}`;
		this._restClient.exec_get(url, callback);
	}
}
